import styled from "styled-components";
import { breakpoints } from "../../../globalStyles";

export const VolumeWrapper = styled.span`
  position: relative;
  & button {
    margin: 0;
  }

  @media ${breakpoints.sm} {
    display: none;
  }
`;

export const VolumeControllerWrapper = styled.span`
  position: absolute;
  width: 42px;
  height: 179px;
  top: -170px;
  left: 50%;
  padding: 10px 40px;
  transform: translateX(-50%);
  animation: mountIn 0.3s ease;

  @keyframes mountIn {
    from {
      opacity: 0;
      transform: translate(-50%, 30px);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }

  // будут работать перед unmount
  opacity: ${({ forUnmountStyles }) => (forUnmountStyles ? "0" : "1")};
  transition: ${({ forUnmountStyles }) =>
    forUnmountStyles ? "all 300ms ease" : "none"};
`;

export const VolumeController = styled.span`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 181px;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  background: var(--card-active);
  border-radius: 4px;
`;

export const VolumeSlider = styled.span`
  position: relative;
  display: flex;
  justify-content: center;
  width: 4px;
  height: 158px;
  background: var(--white-secondary);
`;

export const VolumeThumb = styled.span`
  position: absolute;
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 100%;
  transform: translateY(50%);
  z-index: 10;
  cursor: pointer;
  bottom: ${({ positionBottom }) => positionBottom}%;
  &:active {
    transform: scale(1.1) translateY(50%);
    cursor: grabbing;
  }
`;

export const VolumeTrack = styled.span`
  position: absolute;
  width: 4px;
  height: 0px;
  bottom: 0;
  height: ${({ trackHeight }) => trackHeight}%;
  background-color: ${({ trackBg }) => trackBg ?? "#fff"};
`;
